import { Observable, of } from 'rxjs';
import { HttpBaseService } from '@shared/service/base_services/http_base.service';
import { HttpClient } from '@angular/common/http';
import { LocalRepository } from '@shared/helper/local-repository';
import { Injectable, makeStateKey, TransferState, inject } from '@angular/core';
import { TServiceResult } from '@shared/helper/t-service-result';
import { PageList } from '@shared/model/categoryAndSearch/pageList-model';
import { BooklistAggrigatorModel } from '@app/pages/booklists/models/booklist-aggrigator-model';
import { TermFilterModel } from '@shared/model/categoryAndSearch/term-filter-model';
import { catchError, switchMap } from 'rxjs/operators';

import { Book_BooklistModel } from '@app/pages/booklists/models/Book_Booklist.model';


const STATE_KEY_LAST_WEEK_BOOKLIST = makeStateKey<TServiceResult<PageList<BooklistAggrigatorModel>>>('last_week_booklist_home');
const STATE_KEY_CHOSEN_BOOKLIST = makeStateKey<TServiceResult<PageList<BooklistAggrigatorModel>>>('chosen_booklist_home');
const STATE_KEY_CHOSEN_BOOKLIST_FEEDS = makeStateKey<TServiceResult<PageList<BooklistAggrigatorModel>>>('chosen_booklist_FEEDS');

@Injectable({
    providedIn: 'root'
})

export class BooklistAggrigatorService extends HttpBaseService {
    private serverState = inject(TransferState);


    logger: any

    constructor() {
        const repo = inject(LocalRepository);
        const http = inject(HttpClient);

        super(repo, http, 'v1/blstAggr');
    }

    getAllBookLists(termFilter: TermFilterModel): Observable<TServiceResult<PageList<BooklistAggrigatorModel>>> {
        const param = this.ServiceTermFilter(termFilter);
        return this.http.get<TServiceResult<PageList<BooklistAggrigatorModel>>>(`${this.apiUrl}/GetLatestBookLists/${param}`);
    }

    getAllBookListsWithUserLiked(termFilter: TermFilterModel): Observable<TServiceResult<PageList<BooklistAggrigatorModel>>> {
        const param = this.ServiceTermFilter(termFilter);
        return this.http.get<TServiceResult<PageList<BooklistAggrigatorModel>>>(`${this.apiUrl}/GetLatestBookListsWithUserLiked/${param}`);
    }

    getMyBookLists(termFilter: TermFilterModel): Observable<TServiceResult<PageList<BooklistAggrigatorModel>>> {
        const param = this.ServiceTermFilter(termFilter);
        return this.http.get<TServiceResult<PageList<BooklistAggrigatorModel>>>(`${this.apiUrl}/GetMyBookLists/${param}`);
    }

    getGuestBookLists(term: string, termFilter: TermFilterModel): Observable<TServiceResult<PageList<BooklistAggrigatorModel>>> {
        const param = this.ServiceTermFilter(termFilter);
        return this.http.get<TServiceResult<PageList<BooklistAggrigatorModel>>>(`${this.apiUrl}/GetGuestBookLists/${term}/${param}`)
            .pipe(
                catchError(() => of(new TServiceResult<PageList<BooklistAggrigatorModel>>(new PageList(), '', null, true, ''))
                )
            )
    }

    getBooklistsOfBook(bookId: string, termFilter: TermFilterModel): Observable<TServiceResult<PageList<BooklistAggrigatorModel>>> {
        const param = this.ServiceTermFilter(termFilter);
        return this.http.get<TServiceResult<PageList<BooklistAggrigatorModel>>>(`${this.apiUrl}/GetBooklistsOfBook/${bookId}/${param}`);
    }

    getListDetail(ListId: string): Observable<TServiceResult<BooklistAggrigatorModel>> {
        return this.http.get<TServiceResult<BooklistAggrigatorModel>>(`${this.apiUrl}/Get/${ListId}`);
    }

    getBooksOfBooklist(listId: string, termFilter: TermFilterModel): Observable<TServiceResult<PageList<Book_BooklistModel>>> {
        const param = this.ServiceTermFilter(termFilter);
        return this.http.get<TServiceResult<PageList<Book_BooklistModel>>>(`${this.apiUrl}/GetBooksOfBooklist/${listId}/${param}`);
    }

    getLatestBooklistsOfWeek(temrFilter: TermFilterModel): Observable<TServiceResult<PageList<BooklistAggrigatorModel>>> {
        const param = this.ServiceTermFilter(temrFilter);
        return this.http.get<TServiceResult<PageList<BooklistAggrigatorModel>>>(`${this.apiUrl}/GetLatestBooklistsOfWeek/${param}`);
    }

    getLatestWeekBookLists(temrFilter: TermFilterModel): Observable<TServiceResult<PageList<BooklistAggrigatorModel>>> {
        const param = this.ServiceTermFilter(temrFilter);
        return this.http.get<TServiceResult<PageList<BooklistAggrigatorModel>>>(`${this.apiUrl}/GetLatestWeekBookLists/${param}`)
            .pipe(
                switchMap(res => {
                    this.serverState.set<TServiceResult<PageList<BooklistAggrigatorModel>>>(STATE_KEY_LAST_WEEK_BOOKLIST, res);
                    return of(res)
                })
            )
    }

    getLatestWeekBookListsWithUserLiked(temrFilter: TermFilterModel): Observable<TServiceResult<PageList<BooklistAggrigatorModel>>> {
        const param = this.ServiceTermFilter(temrFilter);
        return this.http.get<TServiceResult<PageList<BooklistAggrigatorModel>>>(`${this.apiUrl}/GetLatestWeekBookListsWithUserLiked/${param}`);
    }



    getChosenBookLists(termFilter: TermFilterModel, tag = 'feed'): Observable<TServiceResult<PageList<BooklistAggrigatorModel>>> {
        const paramsValues = this.ServiceTermFilter(termFilter);
        return this.http.get<TServiceResult<PageList<BooklistAggrigatorModel>>>(`${this.apiUrl}/GetChosenBookLists/${paramsValues}&tag=${tag}`)
            .pipe(
                switchMap(res => {
                    this.serverState.set<TServiceResult<PageList<BooklistAggrigatorModel>>>(STATE_KEY_CHOSEN_BOOKLIST, res)
                    return of(res)
                })
            )
    }

    getChosenBookListsWithUserLiked(termFilter: TermFilterModel, tag = 'feed'): Observable<TServiceResult<PageList<BooklistAggrigatorModel>>> {
        const paramsValues = this.ServiceTermFilter(termFilter);
        return this.http.get<TServiceResult<PageList<BooklistAggrigatorModel>>>(`${this.apiUrl}/GetChosenBookListsWithUserLiked/${paramsValues}&tag=${tag}`)
            .pipe(
                switchMap(res => {
                    this.serverState.set<TServiceResult<PageList<BooklistAggrigatorModel>>>(STATE_KEY_CHOSEN_BOOKLIST_FEEDS, res)
                    return of(res)
                })
            )
    }
}
